<template>
    <v-app  light >
        <v-toolbar  v-if="currentIframeTournament" class="text-xs-center alianza-toolbar" :extended="false" :flat="true" :height="150" app>
          <h3>{{currentIframeTournament.name}}</h3>
        </v-toolbar>
        <main>
            <v-content class="own-flex">
              <v-tabs left :centered="false" color="transparent" v-model="active">
                  <v-tabs-bar class="transparent" color="red">
                      <v-tabs-item
                          light
                          style=""
                          class="tab-item-black"
                          v-for="tab in tabs"
                          :key="tab.key"
                          :href="'#' + tab.key"
                          ripple
                          @click="filter = ''">

                          {{ tab.title }}
                      </v-tabs-item>
                      <v-tabs-slider color="black"></v-tabs-slider>
                  </v-tabs-bar>
                 <v-tabs-items>
                    <!-- TAB 1  Calendario -->
                    <v-tabs-content key="tab1" id="tab1">
                        <v-container fluid grid-list-xs mt-3>
                            <v-layout row wrap>
                                <v-flex xs12 sm12 md12 lg12>
                                  <iframe-calendar></iframe-calendar>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-tabs-content>
                      <!-- TAB 2 Tabla general -->
                      <v-tabs-content key="tab2" id="tab2">
                          <v-container fluid grid-list-xs mt-3>
                              <v-layout row wrap>
                                  <v-flex xs12 sm12 md12 lg12>
                                    <iframe-general-table></iframe-general-table>
                                  </v-flex>
                              </v-layout>
                          </v-container>
                      </v-tabs-content>

                      <!-- TAB 3 Tabla de goleo -->
                      <v-tabs-content key="tab3" id="tab3">
                          <v-container fluid grid-list-xs mt-3>
                              <v-layout row wrap>
                                  <v-flex xs12 sm12 md12 lg12>
                                    <iframe-goals-table></iframe-goals-table>
                                  </v-flex>
                              </v-layout>
                          </v-container>
                      </v-tabs-content>

                      <!-- TAB 4 Tarjetas amarillas -->
                      <v-tabs-content key="tab4" id="tab4">
                          <v-container fluid grid-list-xs mt-3>
                              <v-layout row wrap>
                                  <v-flex xs12 sm12 md12 lg12>
                                    <iframe-yellow-cards></iframe-yellow-cards>
                                  </v-flex>
                              </v-layout>
                          </v-container>
                      </v-tabs-content>

                      <!-- TAB 5 Tarjetas rojas -->
                      <v-tabs-content key="tab5" id="tab5">
                          <v-container fluid grid-list-xs mt-3>
                              <v-layout row wrap>
                                  <v-flex xs12 sm12 md12 lg12>
                                    <iframe-red-cards></iframe-red-cards>
                                  </v-flex>
                              </v-layout>
                          </v-container>
                      </v-tabs-content>


                  </v-tabs-items>
              </v-tabs>
            </v-content>
        </main>
        <v-footer app fixed>
            <span>&copy; 2017</span>
        </v-footer>
    </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Bus from '@/components/bus'
import IframeCalendar from './iframeCalendar'
import IframeGeneralTable from './iframeGeneralTable'
import IframeGoalsTable from './iframeGoalsTable'
import IframeRedCards from './iframeRedCards'
import IframeYellowCards from './iframeYellowCards'



export default {
    name: 'Iframe',
    components: {
      IframeCalendar,
      IframeGeneralTable,
      IframeGoalsTable,
      IframeRedCards,
      IframeYellowCards
    },
    data() {
        return {
          active: 'tab1',
          tabs: [
              { key: 'tab1', title: 'Calendario' },
              { key: 'tab2', title: 'Tabla general' },
              { key: 'tab3', title: 'Tabla de goleo' },
              { key: 'tab4', title: 'Tarjetas amarillas' },
              { key: 'tab5', title: 'Tarjetas rojas' }
              ,
          ]
        }

    },
    computed:{
      ...mapGetters([
        "currentIframeTournament"
      ])
    },
    methods: {
      ...mapActions([
        "loadIframeTournament"
      ])
    },
    mounted() {
      console.log("mounted")
    },
    created() {
      console.log("CREATE")
      this.loadIframeTournament(this.$route.params.tournamentID)
    }
}

</script>

<style lang="css" >
.tab-item-black a.tabs__item--active{
  color:#000000 !important;
}


</style>



// WEBPACK FOOTER //
// src/components/pages/iframe/iframe.vue